import React from 'react';
import { Card, Row, Col } from 'antd';
import { decryptTextByAES } from 'utils/encryption';
import EnumKeyToText from "components/product-price/base/EnumKeyToText";

interface IComponentProps {
	data?: any;
  enums?: any;
}

const BookInfo:React.FC<IComponentProps> = (props) => {
  const { data, enums } = props || {};

  // console.log();


  const { order_info = {}, renewal_order = {} } = data || {};
  const { pickup_info, return_info, tenancy, veh_info, pickup_store, return_store, pickup_driver_name, return_driver_name,pickup_time,return_time } = order_info || {};
  const { veh_plate } = veh_info || {};

  const { pickup_type, return_type } = enums || {};


  const getDefaultText = (text: string) => {
    return text || '--';
  }

  const getPickupType = (type: string) => {
    if (pickup_type) {
      return pickup_type.find((item: any) => item.key === type)?.value || '--';
    } else {
      return '--';
    }
  }

  const getReturnType = (type: string) => {
    if (return_type) {
      return return_type.find((item: any) => item.key === type)?.value || '--';
    } else {
      return '--';
    }
  }

  return (
    <>
      <Card title="预订信息" style={{ marginBottom: 20 }}>
        <Row style={{ marginBottom: 20 }}>
          <Col span={2}>车型信息:</Col><Col span={10}>
            <div>{order_info?.veh_model_info?.brand_name}/{order_info?.veh_model_info?.series_name}/{order_info?.veh_model_info?.model_name}</div>
            <div>
              {order_info.veh_model_info.group_code}
              ｜ <EnumKeyToText data={order_info.veh_model_info} enums={enums} valueKey={'transmission_type'} nameSpace={'transmission_type'} />
              ｜ <EnumKeyToText data={order_info.veh_model_info} enums={enums} valueKey={'fuel_type'} nameSpace={'fule_type'} />
              ｜ {order_info.veh_model_info.passenger_no}座
              ｜ {order_info.veh_model_info.door_no}门
            </div>
          </Col>
          <Col span={2}>车辆信息:</Col><Col span={10}>{veh_plate ? decryptTextByAES(veh_plate) : <span style={{ color: '#FF6400' }}>未排车</span>}</Col>
        </Row>
        <Row style={{ marginBottom: 12 }}>
          <Col span={2}>取车方式:</Col><Col span={4}>{getPickupType(pickup_info?.type)}</Col>
          <Col span={2}>取车司机:</Col><Col span={4}>{getDefaultText(pickup_driver_name)}</Col>
          <Col span={2}>取车网点/门店:</Col><Col span={4}>{getDefaultText(pickup_store?.store_name)}</Col>
          <Col span={2}>取车地址:</Col><Col span={4}>{getDefaultText(pickup_info?.delivery_address)}</Col>
        </Row>
        <Row style={{ marginBottom: 12 }}>
          <Col span={2}>还车方式:</Col><Col span={4}>{getReturnType(return_info?.type)}</Col>
          <Col span={2}>还车司机:</Col><Col span={4}>{getDefaultText(return_driver_name)}</Col>
          <Col span={2}>还车网点/门店:</Col><Col span={4}>{getDefaultText(return_store?.store_name)}</Col>
          <Col span={2}>还车地址:</Col><Col span={4}>{getDefaultText(return_info?.delivery_address)}</Col>
        </Row>
        <Row style={{ marginBottom: 12 }}>
          <Col span={2}>租期:</Col><Col span={10}><span style={{ color: '#FF6400' }}>{getDefaultText(pickup_info?.time)+'~'+getDefaultText(return_info?.time)+ ' ' + getDefaultText(tenancy)}</span></Col>
        </Row>
        <Row style={{ marginBottom: 12 }}>
          <Col span={2}>实际取车时间:</Col><Col span={4}>{getDefaultText(pickup_time)}</Col>
          <Col span={2}>实际还车时间:</Col><Col span={4}>{getDefaultText(return_time)}</Col>
          <Col span={2}>续租还车时间:</Col><Col span={4}>{getDefaultText(renewal_order?.renewal_return_time)}</Col>
        </Row>
      </Card>
    </>
  );
}

export default BookInfo;
